var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIcone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5272 0H8.50294C7.78786 0 6.78972 0.417132 6.2832 0.92365L1.20313 6.00372C0.696613 6.51024 0.696613 7.32961 1.20313 7.83613L4.98712 11.6201C5.49363 12.1266 6.313 12.1266 6.81952 11.6201L11.8996 6.54004C12.4061 6.03352 12.8232 5.03538 12.8232 4.3203V1.29609C12.8232 0.581006 12.2422 0 11.5272 0ZM9.79903 4.3203C9.08395 4.3203 8.50294 3.73929 8.50294 3.02421C8.50294 2.30912 9.08395 1.72812 9.79903 1.72812C10.5141 1.72812 11.0951 2.30912 11.0951 3.02421C11.0951 3.73929 10.5141 4.3203 9.79903 4.3203Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcone);
export default __webpack_public_path__ + "static/media/tagIcone.f8a2447141904533188e141d1ad864e3.svg";
export { ForwardRef as ReactComponent };